/* eslint-disable indent */
import requestApi, { HTTP_METHOD } from '@/utils/axios.http';
import { StructureAdvancedFilter } from '@/entities/structure/group';
import { TCompanySchema } from '@/schemas/company/company.schema';
import { mapStructureFilterAPI } from '@/utils/map.utils';
import { ListAllCompany, TotalActiveCompany } from '../entities/company';
import { TCompanyUserSchema } from '@/schemas/company-user/company-user.schema';
import { TOKEN_API_PUBLIC } from '@/utils/constant.utils';

const COMPANY_URI = '/company';

export const createNewCompany = async (
  company: TCompanySchema,
  query?: TCompanyUserSchema
) => {
  let url = `${COMPANY_URI}`;
  const params = new URLSearchParams();

  if (query?.createdByUserId) {
    params.append('createdByUserId', query?.createdByUserId);
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return requestApi({
    url,
    method: HTTP_METHOD.POST,
    body: company,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getExistingCompany = async (query?: TCompanySchema) => {
  let url = `${COMPANY_URI}/existing`;
  const params = new URLSearchParams();

  if (query?.id) {
    params.append('id', query.id);
  }

  if (query?.name) {
    params.append('name', query.name);
  }

  if (query?.businessIdNumber) {
    params.append('businessIdNumber', query.businessIdNumber);
  }

  if (query?.email) {
    params.append('email', query.email);
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return requestApi({
    url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const listAllCompanies = async (query?: ListAllCompany) => {
  let url = `${COMPANY_URI}/allCompanies`;
  const params = new URLSearchParams();

  if (query?.userId) {
    params.append('userId', query.userId);
  }

  if (query?.distributorId) {
    params.append('distributorId', query.distributorId);
  }

  if (query?.groupId) {
    params.append('groupId', query.groupId);
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return requestApi({
    url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
      'x-api-token': TOKEN_API_PUBLIC,
    },
  });
};

export const getAllCompanies = async (
  filter: StructureAdvancedFilter,
  page: number,
  limit: number,
  sortBy?: string,
  sortDirection?: 'asc' | 'desc'
) => {
  const filterMapped = mapStructureFilterAPI(filter);
  let url = `${COMPANY_URI}/all?${filterMapped}&page=${page}&limit=${limit}`;
  if (sortBy) {
    url += `&sortBy=${sortBy}&sortDirection=${sortDirection || 'asc'}`;
  }
  return requestApi({
    url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getTotalActiveCompanies = async (query?: TotalActiveCompany) => {
  return requestApi({
    url: `${COMPANY_URI}/totalActive${
      query?.groupId
        ? `?groupId=${query?.groupId}`
        : query?.userId
        ? `?userId=${query?.userId}`
        : ''
    }`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getCompanyById = async (id: string) => {
  return requestApi({
    url: `${COMPANY_URI}/${id}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getUnassignedCompaniesToGroup = async (
  loggedInUserId?: string
) => {
  let url = `${COMPANY_URI}/unassignedCompaniesToGroup`;
  const params = new URLSearchParams();

  if (loggedInUserId) {
    params.append('loggedInUserId', loggedInUserId);
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return requestApi({
    url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getAssignedCompaniesToGroup = async (groupId: string) => {
  return requestApi({
    url: `${COMPANY_URI}/assigned/group/${groupId}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getUnassignedCompaniesToUser = async (
  userId: string,
  loggedInUserId?: string
) => {
  let url = `${COMPANY_URI}/unassigned/user/${userId}`;
  const params = new URLSearchParams();

  if (loggedInUserId) {
    params.append('loggedInUserId', loggedInUserId);
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return requestApi({
    url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getAssignedCompaniesToUser = async (userId: string) => {
  return requestApi({
    url: `${COMPANY_URI}/assigned/user/${userId}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const updateCompany = async (company: TCompanySchema) => {
  return requestApi({
    url: `${COMPANY_URI}/update`,
    method: HTTP_METHOD.PATCH,
    body: company,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const updateManyCompanies = async (companies: TCompanySchema[]) => {
  return requestApi({
    url: `${COMPANY_URI}/updateMany`,
    method: HTTP_METHOD.PATCH,
    body: companies,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const findByUser = async (userId: string, roleName: string) => {
  return requestApi({
    url: `${COMPANY_URI}/user/${userId}/role/${roleName}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
